if (!customElements.get("wdn-image-comparison")) {
  class WDNImageComparison extends HTMLElement {
    constructor() {
      super();
      this.id = this.getAttribute("data-id");
      this.mainImage = this.querySelector("[data-image] img");
      this.imageOverlays = this.querySelectorAll("[data-image-overlay]");
      this.isInitted = false;
      this.slider = this.getSliderById(this.id);
      this.swiperParent = this.closest("wdn-swiper");
      this.settings = WDN.ImageCompareConfig;
      this.init();
    }

    getSliderById(reqId) {
      return document.querySelector("[data-comparison-slider='" + reqId + "']");
    }

    setImageWidth(newWidth, unit) {
      var _unit = unit || "px";
      this.currentLoopImage.style.width = newWidth + _unit;
    }

    setHalfWidthImage() {
      this.setImageWidth(this.currentImageWidth / 2);
    }

    setSliderInteractionState(newState) {
      this.isBeingInteracted = newState;
    }

    positionCustomSlider() {
      var imageWidth = this.currentImageWidth;
      var imageHeight = this.currentImageHeight;
      var sliderHeight = this.slider.offsetHeight;
      var sliderWidth = this.slider.offsetWidth;
      this.setSliderTopPos(imageHeight / 2 - sliderHeight / 2);
      this.setSliderLeftPos(imageWidth / 2 - sliderWidth / 2);
    }

    setSliderTopPos(newPosition) {
      if (this.slider) {
        this.slider.style.top = newPosition + "px";
      }
    }

    setSliderLeftPos(newPosition) {
      if (this.slider) {
        this.slider.style.left = newPosition + "px";
      }
    }

    createSlider() {
      var newSlider = document.createElement("div");
      newSlider.setAttribute("data-comparison-slider", this.id);
      newSlider.setAttribute("class", "slider--compare");
      this.currentLoopImage.parentNode.insertBefore(newSlider, this.currentLoopImage);
      this.slider = this.getSliderById(this.id);

      if (this.settings && this.settings.icon) {
        this.slider.innerHTML = this.settings.icon;
      }
    }

    setupSlider() {
      if (!this.slider) {
        this.createSlider();
        this.positionCustomSlider();
        this.bindSlider();
        this.hasCustomSlider = true;
      } else {
        this.updateSliderBackground();
      }
    }

    updateSliderBackground() {
      if (this.slider && this.slider.tagName === "INPUT") {
        var perc = this.slider.value;
        var bgStyle =
          "background:linear-gradient(to right, rgb(51, 51, 51) 0%, rgb(51, 51, 51) " +
          perc +
          "%, rgb(216, 216, 216) " +
          perc +
          "%, rgb(216, 216, 216) 100%);";
        this.slider.style.cssText = bgStyle;
      }
    }

    setupImage() {
      this.setHalfWidthImage();
      this.setupSlider();
    }

    storeImageInfo(image) {
      this.currentLoopImage = image; // storing it on instance to prevent passing it around
      this.currentImageWidth = image.offsetWidth;
      this.currentImageHeight = image.offsetHeight;
    }

    setupImages() {
      this.isInitted = true;
      this.imageOverlays.forEach(function (image) {
        this.storeImageInfo(image);
        this.setupImage();
      }, this);
    }

    enableSwiperTouch() {
      if (this.swiperParent) {
        this.swiperParent.Swiper.allowTouchMove = true;
      }
    }

    disableSwiperTouch() {
      if (this.swiperParent) {
        this.swiperParent.Swiper.allowTouchMove = false;
      }
    }

    sliderOnRelease() {
      this.unbindWindow();
      this.removeClickedState();
      this.enableSwiperTouch();
      this.setSliderInteractionState(false);
      if (this.hasCustomSlider) {
        this.positionSlider();
      }
    }

    getCursorPosition(e) {
      if (e) {
        e = e.changedTouches ? e.changedTouches[0] : e;
        var imageBoundingClient = this.currentLoopImage.getBoundingClientRect();
        var cursorCoor = e.pageX - imageBoundingClient.left;
        var cursorPosition = cursorCoor - window.pageXOffset;
      }
      return cursorPosition || false;
    }

    validateCursorPosition(position) {
      position < 0 ? (position = 0) : "";
      position > this.currentImageWidth ? (position = this.currentImageWidth) : "";
      return position;
    }

    getInputPercentage() {
      return parseInt(this.slider.value) / 100;
    }

    calculateWidthBasedOnInput() {
      var inputPercentage = this.getInputPercentage();
      return this.currentLoopImage.offsetWidth * inputPercentage;
    }

    positionSlider() {
      var sliderLeftPos = this.currentLoopImage.offsetWidth - this.slider.offsetWidth / 2;
      this.setSliderLeftPos(sliderLeftPos);
    }

    slide(position) {
      if (position) {
        this.positionSlider();
        this.updateSliderBackground();
      } else {
        var position = this.calculateWidthBasedOnInput();
      }
      this.setImageWidth(position);
    }

    moveSlider(e) {
      if (this.isBeingInteracted) {
        var cursorPosition = this.getCursorPosition(e);
        var validatedPosition = this.validateCursorPosition(cursorPosition); // prevents going outside of the parent
        this.slide(validatedPosition);
      }
    }

    sliderOnInteraction(e) {
      this.setSliderInteractionState(true);
      this.moveSlider(e);
    }

    sliderOnPress(e) {
      this.sliderOnInteraction(e);
    }

    removeClickedState() {
      if (this.slider) {
        this.slider.removeAttribute("data-slider-active");
      }
    }

    setClickedState() {
      if (this.slider) {
        this.slider.setAttribute("data-slider-active", "");
      }
    }

    setupListeners() {
      this.setClickedState();
      this.disableSwiperTouch();
      this.bindWindow();
    }

    bindSlider() {
      if (this.slider) {
        this.slider.addEventListener("mousedown", this.setupListeners.bind(this));
        this.slider.addEventListener("touchstart", this.setupListeners.bind(this));
      }
    }

    bindWindow() {
      window.addEventListener("mouseup", this.sliderOnReleaseBound);
      window.addEventListener("touchend", this.sliderOnReleaseBound);
      window.addEventListener("mousemove", this.sliderOnInteractionBound);
      window.addEventListener("touchmove", this.sliderOnInteractionBound);
    }

    unbindWindow() {
      window.removeEventListener("mouseup", this.sliderOnReleaseBound);
      window.removeEventListener("touchend", this.sliderOnReleaseBound);
      window.removeEventListener("mousemove", this.sliderOnInteractionBound);
      window.removeEventListener("touchmove", this.sliderOnInteractionBound);
    }

    setupCallbacks() {
      this.sliderOnInteractionBound = this.sliderOnInteraction.bind(this);
      this.sliderOnPressBound = this.sliderOnPress.bind(this);
      this.sliderOnReleaseBound = this.sliderOnRelease.bind(this);
      this.sliderOnInteractionBound = this.sliderOnInteraction.bind(this);
    }

    windowOnResize() {
      this.setImageWidth("100", "%");
      this.setupImages();

      if (this.hasCustomSlider) {
        this.positionCustomSlider();
      }
    }

    listenForResize() {
      window.addEventListener("window:resize", this.windowOnResize.bind(this));
    }

    bind() {
      this.setupCallbacks();
      this.bindSlider();
      this.listenForResize();
    }

    isLazyLoaded() {
      return this.wasLazyLoaded || (this.mainImage.complete && this.mainImage.naturalHeight !== 0);
    }

    onImageLazyLoad() {
      this.wasLazyLoaded = true;
      this.init();
    }

    listenForLazyLoad() {
      this.mainImage.addEventListener("load", this.onImageLazyLoad.bind(this));
    }

    init() {
      if (!this.isInitted) {
        if (this.isLazyLoaded()) {
          this.setupImages();
          this.bind();
        } else {
          this.listenForLazyLoad();
        }
      }
    }
  }

  customElements.define("wdn-image-comparison", WDNImageComparison);
}
